// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pyramid-message-bar {
  display: grid;
  background: #ffffff;
  border: 1.5px solid #1a6a7c;
  border-radius: 3vh;
  text-align: center;
  padding: 5px;
  margin: 0.1vh;
  color: #1a6a7c;
  font-size: 1.2vw; 
}
.pyramid-top-bar-button {
  display: grid;
  grid-template-columns: 74vw auto;
  gap: 2.5vw;
  align-items: end;
}
.pyramid-top-bar {
  display: grid;
grid-template-columns: 12.2vw auto 2.5vw;
  height: min-content;
  gap: 0.5vw;
}

.pyramid-button-setting {
  display: grid;
  place-items: center;
  width: 12.2vw;
  grid-template-columns: repeat(4, max-content);
  gap: 0.5vw;
}
.pyramid-auxButtons {
  display: grid;
  height: auto;
  grid-template-columns: repeat(3, 3.4vw);
  row-gap: 1vw;
  justify-self: center;
  column-gap: 1vw;
}
.pyramid-icon {
  display: grid;
  height: 2.2vw;
  width: 100%;
}
.pyramid-icon:active {
  filter: brightness(0.8);
}

.pyramid-nextButton {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  height: 5.4vw;
}

.pyramid-next {
  height: 2.2vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/PyramidApp/styles/PyramidTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf,wCAAwC;EACtC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,UAAU;AACZ;AACA;EACE,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".pyramid-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 1.5px solid #1a6a7c;\n  border-radius: 3vh;\n  text-align: center;\n  padding: 5px;\n  margin: 0.1vh;\n  color: #1a6a7c;\n  font-size: 1.2vw; \n}\n.pyramid-top-bar-button {\n  display: grid;\n  grid-template-columns: 74vw auto;\n  gap: 2.5vw;\n  align-items: end;\n}\n.pyramid-top-bar {\n  display: grid;\ngrid-template-columns: 12.2vw auto 2.5vw;\n  height: min-content;\n  gap: 0.5vw;\n}\n\n.pyramid-button-setting {\n  display: grid;\n  place-items: center;\n  width: 12.2vw;\n  grid-template-columns: repeat(4, max-content);\n  gap: 0.5vw;\n}\n.pyramid-auxButtons {\n  display: grid;\n  height: auto;\n  grid-template-columns: repeat(3, 3.4vw);\n  row-gap: 1vw;\n  justify-self: center;\n  column-gap: 1vw;\n}\n.pyramid-icon {\n  display: grid;\n  height: 2.2vw;\n  width: 100%;\n}\n.pyramid-icon:active {\n  filter: brightness(0.8);\n}\n\n.pyramid-nextButton {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  height: 5.4vw;\n}\n\n.pyramid-next {\n  height: 2.2vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
